import React from 'react';
import { Alert } from 'react-bootstrap';
import ConfirmationModal from '@enerex/unified-ui-react/ConfirmationModal';
import Select from 'components/UnifiedAsyncSelect';
import Div from 'components/Div';
import Text from 'components/Text';

interface AddChildModalProps {
    show: boolean;
    selectedChildCompanies: any[];
    childError: string;
    onClose: () => void;
    onChildChange: (selectedOptions: any) => void;
    onAdd: () => Promise<void>;
    loadChildOptions: (inputValue: string) => Promise<any[]>;
}

const AddChildModal: React.FC<AddChildModalProps> = ({
    show,
    selectedChildCompanies,
    childError,
    onClose,
    onChildChange,
    onAdd,
    loadChildOptions,
}) => {
    return (
        <ConfirmationModal
            dialogClassName="modal-md"
            centered
            show={show}
            onHide={onClose}
            size="lg"
            title="Add Child Companies"
            confirmButtonLabel="Add Companies as Child"
            onConfirm={() => {
                if (selectedChildCompanies.length === 0) return;
                onAdd();
            }}
        >
                {childError && (
                    <Alert variant="danger">
                        {childError}
                    </Alert>
                )}
                <Div className="mb-3">
                    <Text variant="plain" className="mb-2">
                        Select child companies
                    </Text>
                    <Select
                        isMulti
                        value={selectedChildCompanies}
                        onChange={onChildChange}
                        loadOptions={loadChildOptions}
                        placeholder="Search and select companies..."
                        isClearable
                        isSearchable
                        cacheOptions
                        classNamePrefix="react-select"
                    />
                </Div>
        </ConfirmationModal>
    );
};

export default AddChildModal;

